import React from 'react';
import Dialog from 'material-ui/Dialog/Dialog';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';
import Typography from 'material-ui/Typography';
import {connect} from "react-redux";
import Slide from 'material-ui/transitions/Slide';
import AppTheme from './AppTheme';
import {closeProducts} from "../actions/process";


import {
    addAllProducts,
    addProduct,
    clearProducts,
    removeProduct,
    setHardwareId,
    setLimit,
    setUsername
} from "../actions/filters";
import FilterCheckBox from './FilterCheckBox';
import CommonButton from "./common/CommonButton";
import {productList} from "../service/localStorageService";

const FiltersDialog=({classes,dispatch,show,limit,username,hardwareId})=> {
    return (
        <AppTheme>
            <Dialog
                classes={{ paper: 'dialog-paper' }}
                open={!!(show)}
                TransitionComponent={Slide}
                onEscapeKeyDown={()=>{dispatch(closeProducts())}}
                aria-labelledby="event details">
                <AppBar position="static" color="secondary">
                    <Toolbar>
                        <IconButton color="secondary" onClick={()=>{dispatch(closeProducts())}} aria-label="Close">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <path  fill="#7a7a7a" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                        </IconButton>
                        <Typography variant="title" color="primary" className='details-dialog-flex'>
                            Фильтры
                        </Typography>
                    </Toolbar>
                </AppBar>
                <div className='dialog-content'>
                    Искать по продуктам:
                    <div className='filter-box'>
                    {productList.map((product)=>{
                        return <FilterCheckBox
                                            className = 'filter-flex'
                                            product={product}
                                            handleCheck={(isChecked)=>{
                                                    if(isChecked){
                                                        dispatch(removeProduct(product));
                                                        return;
                                                    }
                                                    dispatch(addProduct(product));
                                                }}
                                                key={product}/>
                        })
                    }
                    </div>
                    <CommonButton onClick={()=>dispatch(addAllProducts())}> Выбрать все </CommonButton>
                    <CommonButton onClick={()=>dispatch(clearProducts())}> Очистить все </CommonButton>
                    <br/>
                    Лимит записей:
                    <input className='app-bar--url-input' name="message" type='number' defaultValue={limit} onChange={(e)=>dispatch(setLimit(e.target.value))}/>
                    <br/>
                    Искать только для имени пользователя:
                    <input className='filter-input' name="message" defaultValue={username} placeholder='Поиск по всем пользователям' onChange={(e)=>dispatch(setUsername(e.target.value))}/>
                    <br/>
                    Искать только для id железа:
                    <input className='filter-input' name="message"  defaultValue={hardwareId} placeholder='Поиск по всему железу' onChange={(e)=>dispatch(setHardwareId(e.target.value))}/>

                </div>
            </Dialog>
        </AppTheme>
    );
};
const mapStateToProps=(state)=>({show:state.process.productsOn,products:state.filters.products,limit:state.filters.limit,username : state.filters.username, hardwareId : state.filters.hardwareId});
const ConnectedFiltersDialog=connect(mapStateToProps)(FiltersDialog);
export default ConnectedFiltersDialog;